import React from 'react';
import { WrapperCardLoading, WrapperShimmer, Iwr, Iws, Iwt, Iwu, Iwv, Iww, Iwx, Iwy, Iwz, Iwa, Iwb, Iwc } from './styled';

const CardLoading = () => (
  <WrapperCardLoading>
    <WrapperShimmer>
      <Iwr />
      <Iws />
      <Iwt />
      <Iwu />
      <Iwv />
      <Iww />
      <Iwx />
      <Iwy />
      <Iwz />
      <Iwa />
      <Iwb />
      <Iwc />
    </WrapperShimmer>
  </WrapperCardLoading>
);

CardLoading.displayName = 'CardLoading';

export default CardLoading;
